import { render } from "./TabNav.vue?vue&type=template&id=5e9f5abe&scoped=true"
import script from "./TabNav.vue?vue&type=script&lang=js"
export * from "./TabNav.vue?vue&type=script&lang=js"

import "./TabNav.vue?vue&type=style&index=0&id=5e9f5abe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e9f5abe"]])

export default __exports__